module.exports = __webpack_public_path__ + "static/img/title_par.e12a256.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/title_par.png
// module id = HGsz
// module chunks = 1